import { render, staticRenderFns } from "./section_main.vue?vue&type=template&id=35306898&scoped=true&"
import script from "./section_main.vue?vue&type=script&lang=js&"
export * from "./section_main.vue?vue&type=script&lang=js&"
import style0 from "./section_main.vue?vue&type=style&index=0&id=35306898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35306898",
  null
  
)

export default component.exports